"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WILDCARD_ENTITY = void 0;
var normalizr_1 = require("normalizr");
exports.WILDCARD_ENTITY = 'CasetivityEntity';
var createUnionSchema = function (entitySchemas) {
    return new normalizr_1.schema.Union(Object.assign.apply(Object, __spreadArray([{}], entitySchemas.map(function (e) {
        var _a;
        return (_a = {}, _a[e.key] = e, _a);
    }), false)), 'entityType');
};
exports.default = createUnionSchema;
//# sourceMappingURL=createUnionSchema.js.map